/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InvitationResponseRole = typeof InvitationResponseRole[keyof typeof InvitationResponseRole];


export const InvitationResponseRole = {
  admin: 'admin',
  member: 'member',
} as const;
